import { Component, Input, OnChanges } from '@angular/core';
import { SortService } from 'app/shared/services/sort-service/sort.service';
import { CmsAlarms } from 'app/models/monitor/cms-alarms.model';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';

@Component({
    selector: 'app-alarms-cms-table',
    templateUrl: './alarms-cms-table.component.html',
    styleUrls: ['./alarms-cms-table.component.scss'],
    standalone: false
})
export class AlarmsCmsTableComponent {

  @Input() alarms: CmsAlarms;
  public showAll = false;

  constructor(private sortService: SortService,
              private themeService: ThemeService,
              public tz: TimezoneService

            ) { }

  // public ngOnChanges(): void {
    // this.sortAlarmsByTemperature();
  // }

  // private sortAlarmsByTemperature(): void {
  //   if (this.alarms) {
  //     this.alarms.alarms = this.sortService.sort(this.alarms.alarms, 'detectionTS', false);
  //   }
  // }

  public sortChanged(direction: boolean, property: string) {
    this.sortService.sort(this.alarms.alarms, property, direction);
  }

  public toggleShowAll(event: any): void {
    this.showAll = event;
  }

  public getTrendColor(trend: string): string {
    const color = trend === 'new' ? '--red' : '--primary';
    return this.themeService.getColor(color);
  }

}
